/*
 * @Descripttion: 
 * @Author: zhongbin.chen
 * @Date: 2021-12-21 14:21:36
 * @LastEditors: zhongbin.chen
 * @LastEditTime: 2021-12-21 21:26:37
 */

import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/Index.vue'

const DisinfectTask: Array<RouteRecordRaw> = [
  {
    path: '/disinfectTask',
    component: Layout,
    redirect: 'noredirect',
    meta: {
      hidden: true,
     title: 'disinfectTask',
     icon: 'disinfectNav',
   },
    children: [
      {
        path: 'ADIBOT',
        component: () => import('@/views/disinfectTask/ADIBOT.vue'),
        name: 'ADIBOT',
        meta: {
          title: 'ADIBOT',
          noCache: true
        },
      },
      {
        path: 'Carbot',
        component: () => import('@/views/disinfectTask/Carbot.vue'),
        name: 'Carbot',
        meta: {
          title: 'Carbot',
          noCache: true
        },
      },
      {
        path: 'Rainbot',
        component: () => import('@/views/disinfectTask/Rainbot.vue'),
        name: 'Rainbot',
        meta: {
          title: 'Rainbot',
          noCache: true
        },
      },
      {
        path: 'taskInfocarbot/:ids',
        component: () => import('@/views/Robot/carbottaskInfo.vue'),
        name: 'taskInfocarbot',
        meta: {
          title: 'carbot任务记录详情',
          noCache: true,
          hidden:true
        },
      },
      {
        path: 'taskInforainbot/:ids',
        component: () => import('@/views/Robot/rainbottaskInfo.vue'),
        name: 'taskInforainbot',
        meta: {
          title: 'rainbot任务记录详情',
          noCache: true,
          hidden:true
        },
      },
      {
        path: 'taskInfoadibot/:ids',
        component: () => import('@/views/Robot/adibottaskInfo.vue'),
        name: 'taskInfoadibot',
        meta: {
          title: 'adibot任务记录详情',
          noCache: true,
          hidden: true
        }
      }
      // {
      //   path: 'Robohub',
      //   component: () => import('@/views/disinfectTask/Robohub.vue'),
      //   name: 'Robohub',
      //   meta: {
      //     title: 'Robohub',
      //     noCache: true
      //   },
      // }
    ]
  },
]

export default DisinfectTask

